import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plus',
  templateUrl: './plus.component.html'
})
export class PlusComponent {
  @Input() color: string;
  @Input() ariaLabel: string = '';
}
